jQuery(function($) {
    $('.form-slide-open').click(function() {
        var form = $('.search-bar');
        var inputVal = form.find('.search-field').val();
        if(inputVal) {
          form.submit();
        } else {
          $('header').toggleClass('form-active');
        }  
    });
});
  